import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
var MasterDataSections = /* @__PURE__ */ ((MasterDataSections2) => {
  MasterDataSections2["AnalysisConfig"] = "AnalysisConfig";
  MasterDataSections2["ControlTowerExperience"] = "ControlTowerExperience";
  MasterDataSections2["ExperimentAlerts"] = "ExperimentAlerts";
  MasterDataSections2["ExperimentExtensions"] = "ExperimentExtensions";
  MasterDataSections2["ExperimentTemplates"] = "ExperimentTemplates";
  MasterDataSections2["ExperimentTrafficFilters"] = "ExperimentTrafficFilters";
  MasterDataSections2["FlightControl"] = "FlightControl";
  MasterDataSections2["JobExecutionMetadata"] = "JobExecutionMetadata";
  MasterDataSections2["MetricSetProperties"] = "MetricSetProperties";
  MasterDataSections2["Monitoring"] = "Monitoring";
  MasterDataSections2["ProgressionTemplates"] = "ProgressionTemplates";
  MasterDataSections2["SystemHealthMessage"] = "SystemHealthMessage";
  MasterDataSections2["TicketCategories"] = "TicketCategories";
  return MasterDataSections2;
})(MasterDataSections || {});
var MasterDataPermissions = /* @__PURE__ */ ((MasterDataPermissions2) => {
  MasterDataPermissions2["AdminPermission"] = "Admin";
  MasterDataPermissions2["ExperimentPermission"] = "Experiment";
  return MasterDataPermissions2;
})(MasterDataPermissions || {});
const getMdsSection = (input, section) => {
  const experimentationGroup = getExperimentationGroupIdFromPath(input.workspaceId, input.managementGroup);
  return MdsDataplaneResources.getConfigWithTypeV2({
    workspaceId: input.workspaceId,
    experimentationGroup,
    section
  });
};
const getMdsSnapshotSection = (input, section) => {
  const experimentationGroup = getExperimentationGroupIdFromPath(input.workspaceId, input.managementGroup);
  return MdsDataplaneResources.getConfigWithTypeV2({
    workspaceId: input.workspaceId,
    experimentationGroup,
    section,
    snapshot: input.snapshotName
  });
};
const getMdsDefaultSnapshotSection = (input) => {
  return MdsDataplaneResources.getDefaultSnapshotV2(input.workspaceId, MasterDataConstants.progressionTemplates);
};
const getMdsPermission = (input, section) => {
  const experimentationGroup = getExperimentationGroupIdFromPath(input.workspaceId, input.managementGroup);
  return MdsDataplaneResources.isAuthorizedRestResult(input.workspaceId, experimentationGroup, section);
};
export {
  MasterDataPermissions,
  MasterDataSections,
  getMdsDefaultSnapshotSection,
  getMdsPermission,
  getMdsSection,
  getMdsSnapshotSection
};
//# sourceMappingURL=mdsData.ducks.utils.js.map
